import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 9.74359C12.6231 9.74359 13.1282 10.2681 13.1282 10.9152L13.1282 16.4694C13.1282 17.1165 12.6231 17.641 12 17.641C11.3769 17.641 10.8718 17.1165 10.8718 16.4694V10.9152C10.8718 10.2681 11.3769 9.74359 12 9.74359ZM11.9925 6.35897C11.3736 6.35897 10.8718 6.86409 10.8718 7.48718C10.8718 8.11027 11.3736 8.61538 11.9925 8.61538H12.0075C12.6265 8.61538 13.1282 8.11027 13.1282 7.48718C13.1282 6.86409 12.6265 6.35897 12.0075 6.35897H11.9925Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
